import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import SideDrawer from 'app/components/CommonStyled/SideDrawer';
import FeedbackDrawer from 'app/components/ContactDrawers/FeedbackDrawer';
import { FilePlusIcon, InfoIcon, SearchIcon } from 'app/components/shared/icons';
import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import { promptSelector } from 'store/reducers/nlp/nlp-reducer';
import { setShowResourceSubmissionModal } from 'store/reducers/resource-submission/resource-submission-reducer';

import useResourcesSearchHistory from '../../ResourcesContent/ResourcesNLPSearch/useResourcesSearchHistory';
import useMyResources from '../../hooks/useMyResources';
import useResourcesReset from '../../hooks/useResourcesReset';
import {
  ResourcesFilterBarShortcutsItem,
  ResourcesFilterBarShortcutsItemLabel,
  ResourcesFilterBarShortcutsTitle,
  ResourcesFilterBarShortcutsWrapper,
} from './styled';

export default function ResourcesFilterBarShortcuts() {
  const { push } = useHistory();
  const reset = useResourcesReset();
  const dispatch = useDispatch();
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const currentPrompt = useSelector(promptSelector);
  const { saveSearch } = useResourcesSearchHistory();
  const { data: myResources } = useMyResources();
  const resourceCreateCTAClickedBehavioralFunction = useBehavioral(
    BEHAVIORALS.RESOURCE_CREATE_CTA_CLICKED
  );
  const resourceGetAssistanceClickedBehavioralFunction = useBehavioral(
    BEHAVIORALS.RESOURCE_GET_ASSISTANCE_CLICKED
  );

  const shortcuts = ['kyu Brand Assets', 'All Credentials'];
  const hasMySubmissions =
    (myResources?.published?.length ?? 0) > 0 || (myResources?.drafts?.length ?? 0) > 0;

  const handleShortcutClick = (shortcut: string) => {
    if (currentPrompt !== shortcut || window.location.pathname !== '/resources') {
      saveSearch(shortcut);
      reset({ prompt: shortcut });

      if (window.location.pathname !== '/resources') {
        push('/resources');
      }
    }
  };

  const handleSubmitResourceClick = () => {
    resourceCreateCTAClickedBehavioralFunction();
    dispatch(setShowResourceSubmissionModal(true));
  };

  const handleGetAssistanceClick = () => {
    resourceGetAssistanceClickedBehavioralFunction();
    setShowDrawer(true);
  };

  const handleMySubmissionsClick = () => {
    push('/resources/my-resources');
  };

  return (
    <ResourcesFilterBarShortcutsWrapper>
      <ResourcesFilterBarShortcutsTitle>QUICK LINKS</ResourcesFilterBarShortcutsTitle>
      {hasMySubmissions ? (
        <ResourcesFilterBarShortcutsItem onClick={handleMySubmissionsClick}>
          <SearchIcon width={20} height={20} fill="var(--color-primary)" />
          <ResourcesFilterBarShortcutsItemLabel>My Submissions</ResourcesFilterBarShortcutsItemLabel>
        </ResourcesFilterBarShortcutsItem>
      ) : null}
      {shortcuts.map((shortcut) => (
        <ResourcesFilterBarShortcutsItem onClick={() => handleShortcutClick(shortcut)}>
          <SearchIcon width={20} height={20} fill="var(--color-primary)" />
          <ResourcesFilterBarShortcutsItemLabel>{shortcut}</ResourcesFilterBarShortcutsItemLabel>
        </ResourcesFilterBarShortcutsItem>
      ))}
      <ResourcesFilterBarShortcutsItem onClick={handleSubmitResourceClick}>
        <FilePlusIcon />
        <ResourcesFilterBarShortcutsItemLabel>
          Submit a resource
        </ResourcesFilterBarShortcutsItemLabel>
      </ResourcesFilterBarShortcutsItem>
      <ResourcesFilterBarShortcutsItem onClick={handleGetAssistanceClick}>
        <InfoIcon width={16} height={16} fill="#000000" />
        <ResourcesFilterBarShortcutsItemLabel>Get assistance</ResourcesFilterBarShortcutsItemLabel>
      </ResourcesFilterBarShortcutsItem>
      {showDrawer ? (
        <SideDrawer closeDrawer={() => setShowDrawer(false)} withClose>
          <FeedbackDrawer />
        </SideDrawer>
      ) : null}
    </ResourcesFilterBarShortcutsWrapper>
  );
}
